<div class="flex min-h-screen flex-col bg-surface-50">
  <header class="flex items-center justify-between border-b border-surface-200 bg-white px-6 py-3 shadow-sm">
    <a routerLink="/" class="flex items-center gap-2 text-lg font-semibold text-surface-900 no-underline">
      <i class="pi pi-shield text-primary"></i>
      Garajet Back Office
    </a>
    <div class="flex items-center gap-4">
      @if (username) {
        <span class="text-sm text-surface-600">
          <i class="pi pi-user mr-1"></i>{{ username }}
        </span>
      }
      <p-button label="Esci" icon="pi pi-sign-out" severity="secondary" size="small" (onClick)="logout()" />
    </div>
  </header>

  <main class="flex-1 p-6">
    <router-outlet />
  </main>

  <p-toast position="top-right" />
</div>
